module.exports = __webpack_public_path__ + "static/media/application_suspended.8abcfaa2.svg";